<div *ngIf="!isConfigComplete" class="alert alert-danger">
  Map needs to be configured before use!
</div>

<google-map *ngIf="markers?.position?.lat > 0" [center]="markers.position"><map-marker [position]="markers.position"
    [label]="markers.label" [title]="markers.title" [options]="markers.options">
  </map-marker></google-map>